/* import __COLOCATED_TEMPLATE__ from './closed-won.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();